import React from 'react';
import '../CSS/styles.css';

const TableComponent = ({ title, columns, rows, tableType }) => {
    return (
        <div className={`table-container ${tableType}`}>
            <h3>{title}</h3>
            <table className="table-wrapper">
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index}>{col}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                {rows && rows.length > 0 ? (
        rows.map((row, rowIndex) => (
          <tr key={rowIndex} style={{fontSize:'16px',fontWeight:'bold'}}>
            {columns.map((col, colIndex) => (
              <td key={colIndex} style={{fontSize:'20px',fontWeight:'normal'}}>{row[col]}</td>  
            ))}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="100%">No data available</td>
        </tr>
      )}
</tbody>
            </table>
        </div>
    );
};

export default TableComponent;
